/*eslint-disable */
import * as actions from './actions';
import mutations from './mutations';
import * as getters from './getters';

const state = {
    itemParts: [],
    itemsForSave:[],
    lastTimeCheck: {
        items: 0,
    },
    claim: {},
    isAutoSaveMessage: '',
};

export default {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};
